"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = exports.StyledMenuContent = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMenuContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: ${({ theme }) => theme.spacing(1.5)};
  max-height: 300px;
  min-width: 300px;

  &.menu-content--searching .MuiTypography-root {
    color: ${({ theme }) => theme.palette.grey[500]};
  }

  .loading-indicator {
    padding: ${({ theme }) => theme.spacing(1)};
  }

  .selected-item {
    background-color: ${({ theme }) => theme.palette.action.selected};
  }

  .checkboxHidden .MuiSvgIcon-root {
    display: none;
  }
  &.single-select .MuiFormControlLabel-root {
    padding: 5px;
  }
`;
exports.StyledTypography = (0, styled_components_1.default)(ui_components_1.Typography) `
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;
